<template>
  <div class="global-update-prompt">
    <div class="available-text">{{ $t("app.newVersion.text") }}</div>

    <div class="button-container">
      <ui-button class="reject-button" size="small" @click="onReject">
        {{ $t("app.newVersion.reject") }}
      </ui-button>

      <ui-button
        class="accept-button"
        size="small"
        type="primary"
        @click="onAccept"
      >
        {{ $t("app.newVersion.accept") }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import { Button } from "amumu-ui"
export default {
  components: {
    "ui-button": Button,
  },
  props: {
    onAccept: {
      type: Function,
      default: () => {},
    },
    onReject: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.global-update-prompt {
  color: #ffffff;
  background: #2a2a2a;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.32);
  border-radius: 4px;
  position: fixed;
  left: 110px;
  bottom: 40px;
  z-index: 3000;
  padding: 16px;
  width: 240px;

  .available-text {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .button-container {
    text-align: right;
  }
  .accept-button {
    margin-left: 8px;
  }
}
</style>
